/**
 * Fetch a short clip ahead of the screen that plays it.
 *
 * Kraben's first-exercise clip used to start downloading only when its screen
 * opened, after a HEAD request that "Start exercise 1" waited on with no sign of
 * life. On a slow connection (owner's phone, 2026-10-08) the button looked
 * broken and then the clip sat on its poster. The clip is a third of a megabyte
 * and the screens before it take half a minute to read, so it is fetched whole
 * while they are read and played from memory: by the time it is wanted it is
 * usually already here, and the video element never waits on the network.
 *
 * Resolves to a blob URL, to `null` when the file is not a video (not shipped,
 * or a host's HTML fallback), and to the plain URL when the fetch itself failed
 * (offline for a moment), so the element can still try the network itself.
 */
const clips = new Map<string, Promise<string | null>>();

export function preloadClip(url: string, poster?: string): Promise<string | null> {
  if (poster) { const im = new Image(); im.src = poster; }
  let p = clips.get(url);
  if (!p) {
    p = fetch(url)
      .then(async (r) => {
        if (!r.ok || !(r.headers.get('content-type') || '').startsWith('video')) return null;
        return URL.createObjectURL(await r.blob());
      })
      .catch(() => url);
    clips.set(url, p);
  }
  return p;
}

